import { combineReducers } from "redux";
import * as c from "./constant";

const cardIntState = { selectedMerchant: null, number: "", pin: "" };

function card(state = cardIntState, action) {
  switch (action.type) {
    case c.SET_DATA:
      return action.card;
    case c.RESET_DATA:
      return cardIntState;
    default:
      return state;
  }
}

export default combineReducers({ card });
